import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { shareCampaign } from '../../../../services/api';
import toast from 'react-hot-toast';

const ShareCampaignModal = ({ isOpen, onClose, campaign }) => {
  const [email, setEmail] = useState('');
  const [isSharing, setIsSharing] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      toast.error('Please enter an email address');
      return;
    }

    setShowConfirmation(true);
  };

  const handleConfirmShare = async () => {
    setIsSharing(true);
    try {
      const result = await shareCampaign(campaign.id, email.trim());
      toast.success(result.message);
      resetAndClose();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSharing(false);
    }
  };

  const resetAndClose = () => {
    setEmail('');
    setShowConfirmation(false);
    setIsSharing(false);
    onClose();
  };

  const handleClose = () => {
    resetAndClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">
            Share Campaign
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <IoClose size={24} />
          </button>
        </div>

        {!showConfirmation ? (
          <>
            <div className="mb-4">
              <p className="text-gray-600 mb-2">
                Share <span className="font-semibold">"{campaign?.title}"</span> with another user
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Recipient Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email address"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
                  required
                />
              </div>

              <div className="flex space-x-3">
                <button
                  type="button"
                  onClick={handleClose}
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                >
                  Share Campaign
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="space-y-4">
            <div className="mb-4">
              <p className="text-gray-600">
                Share <span className="font-semibold">"{campaign?.title}"</span> with <span className="font-semibold">"{email}"</span>?
              </p>
            </div>

            <div className="flex space-x-3">
              <button
                type="button"
                onClick={() => setShowConfirmation(false)}
                className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md transition-colors"
                disabled={isSharing}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirmShare}
                className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSharing}
              >
                {isSharing ? 'Sharing...' : 'Yes, Share'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareCampaignModal;
